module.exports = __webpack_public_path__ + "img/1.495182bb.png";